import moment from "moment"

export function statsTimePeriod(): string {
  // stats data received from the data warehouse resets every July 1 <current_year>
  const academicMonth = "07"
  const academicDay = "01"
  const thisYear = moment().year()
  const previousYear = moment().subtract(1, "years").year()

  if (moment().isAfter(`${thisYear}-${academicMonth}-${academicDay}`)) {
    return moment(`${thisYear}-${academicMonth}-${academicDay}`).format(
      "MMM Do YYYY",
    )
  } else {
    return moment(`${previousYear}-${academicMonth}-${academicDay}`).format(
      "MMM Do YYYY",
    )
  }
}
